// extracted by mini-css-extract-plugin
module.exports = {"noticiasLogo":"styles_noticiasLogo__2rLCX","logo":"styles_logo__q5l8i","white":"styles_white__2p720","black":"styles_black__1mni3","active":"styles_active__1XVoF"};